import React from "react";

export default function Header({ title = "", des = "" }) {
  return (
    <header className="text-center py-12 text-white bg-[#0A1620] ">
      <div>
        {" "}
        <h1 className="text-4xl font-bold">{title}</h1>
        <p className="mt-2 text-lg">{des}</p>
      </div>
    </header>
  );
}
